import { createContext, useContext } from 'react';
export var LayoutContext = /*#__PURE__*/ createContext({ isProfileExpanded: true, expandProfile: function expandProfile() { return console.warn('no layout provider'); } });
export var useLayout = function useLayout() { return useContext(LayoutContext); };
